var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-error"},[_c('HelperView',{attrs:{"icon":"EF0060","type":"alert","title":"Houve um problema ao carregar as movimentações","description":"Aguarde um momento e tente novamente","button-label":"Tentar novamente"},on:{"click":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }